<template lang="pug">
#filters-wrapper
  b-row
    //- Pending tasks
    b-col(md="4", class="pb-2 d-flex align-items-center", v-if="pendingTasksFilterShow")
      b-form-checkbox(
        id="checkbox-1"
        v-model="pendingTasksFilter"
        name="checkbox-1"
        :value="true"
        :unchecked-value="false"
      )
        | {{ $t('label.filterByPendingTasks') }}

    //- Zone
    b-col(md="4", class="pb-2", v-if="zoneFilterShow")
      v-select(
        v-model="zoneFilter",
        :multiple="true",
        :options="metadataFilterOptions.zone",
        :placeholder= "$t('zone_filter')"
      )

    //- Agency
    b-col(md="4", class="pb-2", v-if="agencyFilterShow")
      v-select(
        v-model="agencyFilter",
        :multiple="true",
        :options="metadataFilterOptions.agency",
        :placeholder= "$t('agency_filter')"
      )

    //- Company
    b-col(md="4", class="pb-2", v-if="companyFilterShow")
      v-select(
        v-model="companyFilter",
        :reduce="(company) => company.value",
        :multiple="true",
        label="title",
        :options="companies",
        :placeholder="$t('company_filter')",
      )

    //- Location
    b-col(md="4", class="pb-2", v-if="locationFilterShow")
      v-select(
        v-model="locationFilter",
        :reduce="(locations) => locations.value",
        :multiple="true",
        label="title",
        :options="locations",
        :placeholder= "$t('location_filter')"
      )

    //- Activity (ID)
    b-col(md="4", class="pb-2", v-if="activityFilterShow")
      v-select(
        v-model="idFilter",
        :reduce="(id) => id.value",
        :multiple="true",
        label="title",
        :options="ids",
        :placeholder="$t('activity_filter')",
      )

    //- Role
    b-col(md="4", class="pb-2", v-if="roleFilterShow")
      v-select(
        v-model="roleFilter",
        :reduce="(roles) => roles.value",
        :multiple="true",
        label="title",
        :options="roles",
        :placeholder="$t('role_filter')",
      )

    //- Privilege
    b-col(md="4", class="pb-2", v-if="privilegeFilterShow")
      v-select(
        v-model="privilegeFilter",
        :reduce="(privileges) => privileges.value",
        :multiple="true",
        label="title",
        :options="privilegeOptions",
        :placeholder="$t('privilege_filter')",
      )

    //- Process
    b-col(md="4", class="pb-2", v-if="processFilterShow")
      v-select(
        v-model="processFilter",
        :reduce="(processes) => processes.value",
        :multiple="true",
        label="title",
        :options="processes",
        :placeholder="$t('process_filter')",
      )

    //- Risk
    b-col(md="4", class="pb-2", v-if="riskFilterShow")
      v-select(
        v-model="riskFilter",
        :reduce="(risks) => risks.value",
        :multiple="true",
        label="title",
        :options="processes",
        :placeholder="$t('risk_filter')",
      )

    //- Worker
    b-col(md="4", class="pb-2", v-if="workerFilterShow")
      v-select(
        v-model="workerFilter",
        :reduce="(workersSupervised) => workersSupervised.value",
        :multiple="true",
        label="title",
        :options="workersSupervised",
        :selectable="worker => !worker.deleted",
        :placeholder="$t(workerPlaceholderVariable)",
      )

    //- Supervisor
    b-col(md="4", class="pb-2", v-if="supervisorFilterShow")
      v-select(
        v-model="supervisorFilter",
        :reduce="(supervisors) => supervisors.value",
        :multiple="true",
        label="title",
        :options="supervisors",
        :selectable="worker => !worker.deleted",
        :placeholder="$t('supervisor_filter')",
      )

    //- Observer
    b-col(md="4", class="pb-2", v-if="observerFilterShow")
      v-select(
        v-model="observerFilter",
        :reduce="(supervisors) => supervisors.value",
        :multiple="true",
        label="title",
        :options="supervisors",
        :selectable="worker => !worker.deleted",
        :placeholder="$t('observer_filter')",
      )

    //- Creator
    b-col(md="4", class="pb-2", v-if="creatorFilterShow")
      v-select(
        v-model="creatorFilter",
        :reduce="(supervisors) => supervisors.value",
        :multiple="true",
        label="title",
        :options="supervisors",
        :selectable="worker => !worker.deleted",
        :placeholder="$t('creator_filter')",
      )

    //- Month
    b-col(md="4", class="pb-2", v-if="monthFilterShow")
      v-select(
        v-model="monthFilter",
        :reduce="(months) => months.value",
        label="title",
        :options="months",
        :placeholder="$t('month_filter')",
      )

    //- Year
    b-col(md="4", class="pb-2", v-if="yearFilterShow")
      v-select(
        v-model="yearFilter",
        :options="years",
        :placeholder="$t('year_filter')",
      )

    //- Date range
    b-col(:md="resetDateButtonShow ? '3' : '4'", :class="`pb-2 ${resetDateButtonShow ? 'pr-0' : ''}`", v-if="dateRangeFilterShow")
      flat-pickr(
        v-model="dateRangeFilter",
        class="form-control",
        :config="datePickerConfig",
        :placeholder="resetDateButtonShow ? $t('due_date_filter'): ''"
      )
    b-col(md="1", class="pb-2 pl-0", v-if="resetDateButtonShow")
      delete-button(@clicked="resetDate", v-b-tooltip.hover.v-danger.top="$t('reset_date_filter')")

    //- Metadata of type 'select'
    b-col(md="4", class="pb-2", v-if="metadataFilterShow")
      v-select(
        v-model="metadataFilter",
        :reduce="(metadata) => metadata.value",
        label="title",
        :options="metadataTypeSelect.value",
        :placeholder="$t('metadata_filter')",
      )

    //- Metadata filters for continuous improvement tab
    //- Instance
    b-col(md="4", class="pb-2", v-if="instanceFilterShow")
      v-select(
        v-model="instanceFilter",
        :multiple="true",
        :options="optionsMetadata.instance",
        :placeholder="$t('instance_filter')",
      )
    //- Instance Leader
    b-col(md="4", class="pb-2", v-if="instanceLeaderFilterShow")
      v-select(
        v-model="instanceLeaderFilter",
        :multiple="true",
        :options="optionsMetadata.instance_leader",
        :placeholder="$t('instance_leader_filter')",
      )
    //- Zone
    b-col(md="4", class="pb-2", v-if="zoneImprovementFilterShow")
      v-select(
        v-model="zoneImprovementFilter",
        :multiple="true",
        :options="optionsMetadata.zone",
        :placeholder="$t('zone_filter')",
      )

    //- Privacy filters (Treatments)
    //- Rol
    b-col(md="4", class="pb-2", v-if="rolPrivacyFilterShow")
      v-select(
        v-model="rolPrivacyFilter",
        label="title"
        :options="rolPrivacyOptions"
        :reduce="rol => rol.value",
        :placeholder="$t('Rol')",
        :clearable="true"
      )

    //- Volumen
    b-col(md="4", class="pb-2", v-if="volumenFilterShow")
      v-select(
        v-model="volumenFilter",
        label="title"
        :options="volumenOptions"
        :reduce="volumen => volumen.value",
        :placeholder="$t('Volumen')",
        :clearable="true"
      )

    //- Ámbito
    b-col(md="4", class="pb-2", v-if="ambitoFilterShow")
      v-select(
        v-model="ambitoFilter",
        label="title"
        :options="ambitoOptions"
        :reduce="ambito => ambito.value",
        :placeholder="$t('Ámbito')",
        :clearable="true"
      )

    //- Tiene Sensibles
    b-col(md="4", class="pb-2", v-if="sensiblesFilterShow")
      v-select(
        v-model="sensiblesFilter",
        :options="[{ label: 'Sí', value: true }, { label: 'No', value: false }]",
        :reduce="option => option.value",
        :placeholder="$t('Tiene Sensibles')",
        :clearable="true"
      )

    //- Transferencia Internacional
    b-col(md="4", class="pb-2", v-if="transferenciaFilterShow")
      v-select(
        v-model="transferenciaFilter",
        :options="[{ label: 'Sí', value: true }, { label: 'No', value: false }]",
        :reduce="option => option.value",
        :placeholder="$t('Transferencia Int.')",
        :clearable="true"
      )

    //- Nivel de Riesgo (para ARI/ARR)
    b-col(md="4", class="pb-2", v-if="levelFilterShow")
      v-select(
        v-model="levelFilter",
        label="label"
        :options="levelOptions"
        :reduce="level => level.value",
        :placeholder="$t('Nivel de Riesgo')",
        :clearable="true"
      )

    //- EIPD Requerida (para ARI)
    b-col(md="4", class="pb-2", v-if="eipdFilterShow")
      v-select(
        v-model="eipdFilter",
        :options="[{ label: 'Sí', value: true }, { label: 'No', value: false }]",
        :reduce="option => option.value",
        :placeholder="$t('EIPD Requerida')",
        :clearable="true"
      )

    //- Decisión (para ARR)
    b-col(md="4", class="pb-2", v-if="decisionFilterShow")
      v-select(
        v-model="decisionFilter",
        label="label"
        :options="decisionOptions"
        :reduce="decision => decision.value",
        :placeholder="$t('Decisión')",
        :clearable="true"
      )

    //- Estado del Plan (para ARR y GAP)
    b-col(md="4", class="pb-2", v-if="statusFilterShow")
      v-select(
        v-model="statusFilter",
        label="label"
        :options="statusOptions"
        :reduce="status => status.value",
        :placeholder="$t(statusPlaceholderVariable)",
        :clearable="true"
      )

    //- Estado GAP (estado de la brecha)
    b-col(md="4", class="pb-2", v-if="gapStatusFilterShow")
      v-select(
        v-model="gapStatusFilter",
        label="label"
        :options="gapStatusOptions"
        :reduce="status => status.value",
        :placeholder="$t('Estado')",
        :clearable="true"
      )

    //- Obligación GAP
    b-col(md="4", class="pb-2", v-if="obligationFilterShow")
      v-select(
        v-model="obligationFilter",
        label="title"
        :options="obligations"
        :reduce="obligation => obligation.value",
        :placeholder="$t('Obligación')",
        :clearable="true"
      )

    //- Brechas con planes vencidos
    b-col(md="4", class="pb-2 d-flex align-items-center", v-if="overdueGapsFilterShow")
      b-form-checkbox(
        id="checkbox-overdue-gaps"
        v-model="overdueGapsFilter"
        name="checkbox-overdue-gaps"
        :value="true"
        :unchecked-value="false"
      )
        | {{ $t('Brechas con planes vencidos') }}

    //- Crime
    b-col(md="4", class="pb-2", v-if="crimeFilterShow")
      v-select(
        v-model="crimeFilter",
        :reduce="(crime) => crime.value",
        :multiple="true",
        label="title",
        :options="crimes",
        :placeholder="$t('crime_filter')",
      )

    //- Control
    b-col(md="4", class="pb-2", v-if="controlFilterShow")
      v-select(
        v-model="controlFilter",
        :reduce="(control) => control.value",
        :multiple="true",
        label="title",
        :options="controls",
        :placeholder="$t('control_filter')",
      )

    //- Control Responsible
    b-col(md="4", class="pb-2", v-if="controlResponsibleFilterShow")
      v-select(
        v-model="controlResponsibleFilter",
        :reduce="(responsible) => responsible.value",
        :multiple="true",
        label="title",
        :options="responsibles",
        :placeholder="$t('control_responsible_filter')",
      )

    //- Process code type
    b-col(md="4", class="pb-2", v-if="processTypeFilterShow")
      v-select(
        v-model="processTypeFilter",
        :reduce="(processType) => processType.value",
        :multiple="true",
        label="title",
        :options="processTypes",
        :placeholder="$t('process_type_filter')",
      )

    //- Process Responsible (Worker Filter for responsibles/leadResponsibles)
    b-col(md="4", class="pb-2", v-if="processResponsibleFilterShow")
      v-select(
        v-model="processResponsibleFilter",
        :reduce="(worker) => worker.value",
        :multiple="true",
        label="title",
        :options="workersSupervised",
        :selectable="worker => !worker.deleted",
        :placeholder="$t('responsible_filter')",
      )

    //- Inherent Risk
    b-col(md="4", class="pb-2", v-if="inherentRiskFilterShow")
      v-select(
        v-model="inherentRiskFilter",
        label="label"
        :options="riskLevelOptions"
        :reduce="risk => risk.value",
        :placeholder="$t('inherent_risk_filter')",
        :clearable="true"
      )

    //- Residual Risk
    b-col(md="4", class="pb-2", v-if="residualRiskFilterShow")
      v-select(
        v-model="residualRiskFilter",
        label="label"
        :options="riskLevelOptions"
        :reduce="risk => risk.value",
        :placeholder="$t('residual_risk_filter')",
        :clearable="true"
      )

    //- ARSOPBL filters
    //- Right
    b-col(md="4", class="pb-2", v-if="arsopblRightFilterShow")
      v-select(
        v-model="arsopblRightFilter",
        label="label"
        :options="arsopblRightOptions"
        :reduce="opt => opt.value",
        :placeholder="$t('arsopbl.all_rights')",
        :clearable="true"
      )

    //- Stage
    b-col(md="4", class="pb-2", v-if="arsopblStageFilterShow")
      v-select(
        v-model="arsopblStageFilter",
        label="label"
        :options="arsopblStageOptions"
        :reduce="opt => opt.value",
        :placeholder="$t('arsopbl.all_stages')",
        :clearable="true"
      )

    //- Deadline
    b-col(md="4", class="pb-2", v-if="arsopblDeadlineFilterShow")
      v-select(
        v-model="arsopblDeadlineFilter",
        label="label"
        :options="arsopblDeadlineOptions"
        :reduce="opt => opt.value",
        :placeholder="$t('arsopbl.deadline_filter')",
        :clearable="true"
      )
</template>

<script>
import {
  onMounted, onUnmounted, ref, watch, computed,
} from '@vue/composition-api'
import vSelect from 'vue-select'
import useCommon from '@/views/organization/useCommon'
import i18n from '@/libs/i18n'
import flatPickr from 'vue-flatpickr-component'
import DeleteButton from '@/views/components/Shared/Buttons/DeleteButton'
import { VBTooltip, BFormCheckbox } from 'bootstrap-vue'
import store from '@/store'
import { EventBus } from '@/views/habit/EventBus.js'
import { Spanish } from 'flatpickr/dist/l10n/es.js'
import { flatPickrConfig, processTypes, rolPrivacyOptions, ambitoOptions, volumenOptions, riskLevelOptions } from '@/constants'

export default {
  components: {
    vSelect,
    flatPickr,
    DeleteButton,
    BFormCheckbox,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  props: {
    locationFilterShow: {
      type: Boolean,
      default: false,
    },
    roleFilterShow: {
      type: Boolean,
      default: false,
    },
    privilegeFilterShow: {
      type: Boolean,
      default: false,
    },
    processFilterShow: {
      type: Boolean,
      default: false,
    },
    processTypeFilterShow: {
      type: Boolean,
      default: false,
    },
    riskFilterShow: {
      type: Boolean,
      default: false,
    },
    workerFilterShow: {
      type: Boolean,
      default: false,
    },
    supervisorFilterShow: {
      type: Boolean,
      default: false,
    },
    observerFilterShow: {
      type: Boolean,
      default: false,
    },
    creatorFilterShow: {
      type: Boolean,
      default: false,
    },
    monthFilterShow: {
      type: Boolean,
      default: false,
    },
    yearFilterShow: {
      type: Boolean,
      default: false,
    },
    pendingTasksFilterShow: {
      type: Boolean,
      default: false,
    },
    dateRangeFilterShow: {
      type: Boolean,
      default: false,
    },
    calendarMonth: {
      type: Number,
    },
    calendarYear: {
      type: Number,
    },
    dateRangeDaysLimit: {
      type: Number,
      default: 90,
    },
    resetDateButtonShow: {
      type: Boolean,
      default: false,
    },
    instanceFilterShow: {
      type: Boolean,
      default: false,
    },
    instanceLeaderFilterShow: {
      type: Boolean,
      default: false,
    },
    zoneImprovementFilterShow: {
      type: Boolean,
      default: false,
    },
    zoneFilterShow: {
      type: Boolean,
      default: false,
    },
    agencyFilterShow: {
      type: Boolean,
      default: false,
    },
    metadataFilterShow: {
      type: Boolean,
      default: false,
    },
    locationDefaultValue: {
      type: Boolean,
      default: false,
    },
    workerDefaultValue: {
      type: String,
      default: '',
    },
    workerPlaceholderVariable: {
      type: String,
      default: 'worker_filter',
    },
    // Privacy filters
    rolPrivacyFilterShow: {
      type: Boolean,
      default: false,
    },
    volumenFilterShow: {
      type: Boolean,
      default: false,
    },
    ambitoFilterShow: {
      type: Boolean,
      default: false,
    },
    sensiblesFilterShow: {
      type: Boolean,
      default: false,
    },
    transferenciaFilterShow: {
      type: Boolean,
      default: false,
    },
    levelFilterShow: {
      type: Boolean,
      default: false,
    },
    eipdFilterShow: {
      type: Boolean,
      default: false,
    },
    decisionFilterShow: {
      type: Boolean,
      default: false,
    },
    statusFilterShow: {
      type: Boolean,
      default: false,
    },
    statusPlaceholderVariable: {
      type: String,
      default: 'Estado Plan',
    },
    gapStatusFilterShow: {
      type: Boolean,
      default: false,
    },
    obligationFilterShow: {
      type: Boolean,
      default: false,
    },
    overdueGapsFilterShow: {
      type: Boolean,
      default: false,
    },
    companyFilterShow: {
      type: Boolean,
      default: false,
    },
    activityFilterShow: {
      type: Boolean,
      default: false,
    },
    processResponsibleFilterShow: {
      type: Boolean,
      default: false,
    },
    controlResponsibleFilterShow: {
      type: Boolean,
      default: false,
    },
    crimeFilterShow: {
      type: Boolean,
      default: false,
    },
    controlFilterShow: {
      type: Boolean,
      default: false,
    },
    // ARSOPBL filters
    arsopblRightFilterShow: {
      type: Boolean,
      default: false,
    },
    arsopblStageFilterShow: {
      type: Boolean,
      default: false,
    },
    arsopblDeadlineFilterShow: {
      type: Boolean,
      default: false,
    },
    inherentRiskFilterShow: {
      type: Boolean,
      default: false,
    },
    residualRiskFilterShow: {
      type: Boolean,
      default: false,
    },
  },

  setup(props, { emit }) {
    const {
      getRolesForDropDown, roles, getSupervisorsForDropDown, supervisors, getLocationsForDropDown, locations, getProcessesForDropDown, processes, getWorkersSupervisedForDropDown, workersSupervised, getMetadataForDropDown, metadataFilterOptions, metadataTypeSelect, getCompaniesForDropDown, companies, getIDsForDropDown, ids, getCrimesForDropDown, crimes, getResponsiblesForDropDown, responsibles, getControlsForDropDown, controls, getGapObligationsForDropDown, obligations,
    } = useCommon()

    const userData = store.state?.userStore?.userData
    const userLocations = userData.locations?.length ? userData.locations : null
    const { default_language } = JSON.parse(localStorage.getItem('clientData') || '{}')
    const locationFilter = ref(props.locationDefaultValue && userLocations ? userLocations.map(e => e.value) : [])
    const roleFilter = ref([])
    const privilegeFilter = ref([])
    // worker.privileges siempre es uno de estos 4 valores fijos — sin dropdown a la base,
    // mismas labels ya traducidas que usa el selector de Privilegios en Organization/Worker.
    const privilegeOptions = [
      { title: i18n.t('userRoles.Consultant'), value: 'consultant' },
      { title: i18n.t('userRoles.Manager'), value: 'manager' },
      { title: i18n.t('userRoles.Supervisor'), value: 'supervisor' },
      { title: i18n.t('userRoles.Employee'), value: 'employee' },
    ]

    // Usar filtro de proceso desde el store global
    const processFilter = computed({
      get: () => store.state.filtersStore.processFilter,
      set: (value) => store.dispatch('filtersStore/setProcessFilter', value),
    })

    // Usar filtros desde el store global
    const companyFilter = computed({
      get: () => store.state.filtersStore.companyFilter,
      set: (value) => store.dispatch('filtersStore/setCompanyFilter', value),
    })

    const idFilter = computed({
      get: () => store.state.filtersStore.idFilter,
      set: (value) => store.dispatch('filtersStore/setIdFilter', value),
    })

    const crimeFilter = computed({
      get: () => store.state.filtersStore.crimeFilter,
      set: (value) => store.dispatch('filtersStore/setCrimeFilter', value),
    })

    const controlFilter = computed({
      get: () => store.state.filtersStore.controlFilter,
      set: (value) => store.dispatch('filtersStore/setControlFilter', value),
    })

    const processResponsibleFilter = computed({
      get: () => store.state.filtersStore.processResponsibleFilter,
      set: (value) => store.dispatch('filtersStore/setProcessResponsibleFilter', value),
    })

    const processTypeFilter = ref([])
    const riskFilter = ref([])
    const workerFilter = ref(props.workerDefaultValue ? [props.workerDefaultValue] : [])
    const supervisorFilter = ref([])
    const observerFilter = ref([])
    const creatorFilter = ref([])
    const controlResponsibleFilter = ref([])
    const instanceFilter = ref([])
    const instanceLeaderFilter = ref([])
    const zoneImprovementFilter = ref([])
    const isDatePickerOpen = ref(false)
    const optionsMetadata = computed(() => store.state['app-todo'].optionsMetadata)
    const zoneFilter = ref([])
    const agencyFilter = ref([])
    const metadataFilter = ref('')
    const pendingTasksFilter = ref(false)

    // Privacy filters
    const rolPrivacyFilter = ref(null)
    const volumenFilter = ref(null)
    const ambitoFilter = ref(null)
    const sensiblesFilter = ref(null)
    const transferenciaFilter = ref(null)
    const levelFilter = ref(null)
    const eipdFilter = ref(null)
    const decisionFilter = ref(null)
    const statusFilter = ref(null)
    const gapStatusFilter = ref(null)
    const obligationFilter = ref(null)
    const overdueGapsFilter = ref(false)

    // ARSOPBL filters
    const arsopblRightFilter = ref(null)
    const arsopblStageFilter = ref(null)
    const arsopblDeadlineFilter = ref(null)

    // Risk filters
    const inherentRiskFilter = ref(null)
    const residualRiskFilter = ref(null)

    const arsopblRightOptions = [
      { label: `${i18n.t('arsopbl.right_acc')} (ACC)`, value: 'ACC' },
      { label: `${i18n.t('arsopbl.right_rect')} (RECT)`, value: 'RECT' },
      { label: `${i18n.t('arsopbl.right_supr')} (SUPR)`, value: 'SUPR' },
      { label: `${i18n.t('arsopbl.right_opo')} (OPO)`, value: 'OPO' },
      { label: `${i18n.t('arsopbl.right_port')} (PORT)`, value: 'PORT' },
      { label: `${i18n.t('arsopbl.right_bloq')} (BLOQ)`, value: 'BLOQ' },
      { label: `${i18n.t('arsopbl.right_limi')} (LIMI)`, value: 'LIMI' },
    ]

    const arsopblStageOptions = [
      { label: i18n.t('arsopbl.stage_reception'), value: 'reception' },
      { label: i18n.t('arsopbl.stage_identity_validation'), value: 'identity_validation' },
      { label: i18n.t('arsopbl.stage_analysis'), value: 'analysis' },
      { label: i18n.t('arsopbl.stage_execution'), value: 'execution' },
      { label: i18n.t('arsopbl.stage_response'), value: 'response' },
      { label: i18n.t('arsopbl.stage_closure'), value: 'closure' },
    ]

    const arsopblDeadlineOptions = [
      { label: i18n.t('arsopbl.deadline_on_time'), value: 'on_time' },
      { label: i18n.t('arsopbl.deadline_near_deadline'), value: 'near_deadline' },
      { label: i18n.t('arsopbl.deadline_urgent'), value: 'urgent' },
      { label: i18n.t('arsopbl.deadline_overdue'), value: 'overdue' },
    ]

    const levelOptions = [
      { label: 'Bajo', value: 'Bajo' },
      { label: 'Medio', value: 'Medio' },
      { label: 'Alto', value: 'Alto' },
      { label: 'Muy Alto', value: 'Muy Alto' },
      { label: 'Crítico', value: 'Crítico' },
    ]

    const decisionOptions = [
      { label: 'Aceptar', value: 'Aceptar' },
      { label: 'Mitigar', value: 'Mitigar' },
      { label: 'Transferir', value: 'Transferir' },
      { label: 'Evitar', value: 'Evitar' },
    ]

    const statusOptions = [
      { label: 'Pendiente', value: 'Pendiente' },
      { label: 'En progreso', value: 'En progreso' },
      { label: 'Cerrado', value: 'Cerrado' },
    ]

    const gapStatusOptions = [
      { label: 'Implementado', value: 'Implementado' },
      { label: 'Parcial', value: 'Parcial' },
      { label: 'No implementado', value: 'No implementado' },
      { label: 'No aplica', value: 'No aplica' },
    ]

    const datePickerConfig = ref({
      ...flatPickrConfig,
      mode: 'range',
      dateFormat: default_language === 'en' ? 'm-d-Y' : 'd-m-Y',
      locale: default_language === 'en' ? null : Spanish,
      minDate: null,
      maxDate: null,
      onOpen(selectedDates, dateStr, instance) {
        isDatePickerOpen.value = true
      },
      onClose(selectedDates, dateStr, instance) {
        isDatePickerOpen.value = false
      },
      onChange(selectedDates, dateStr, instance) {
        if (!isDatePickerOpen.value) emitChangeFilter()
      },
      errorHandler(error) {
        // Don't show error message in console if date has been cleared
        if (dateRangeFilter.value) console.log(error)
      },
    })

    const now = new Date()
    const currentMonth = now.getMonth()
    const currentYear = now.getFullYear()
    const currentDay = now.getDate()
    const lastDayOfMonthDate = new Date(currentYear, currentMonth + 1, 0)
    const lastDayOfMonthNumber = lastDayOfMonthDate.getDate()
    const oneYearBeforeDate = new Date(currentYear, currentMonth, currentDay - 365)
    const thirtyDaysBeforeDate = new Date(currentYear, currentMonth, currentDay - 30)

    const months = computed(() => [
      { title: i18n.t('month.january'), value: 1 },
      { title: i18n.t('month.february'), value: 2 },
      { title: i18n.t('month.march'), value: 3 },
      { title: i18n.t('month.april'), value: 4 },
      { title: i18n.t('month.may'), value: 5 },
      { title: i18n.t('month.june'), value: 6 },
      { title: i18n.t('month.july'), value: 7 },
      { title: i18n.t('month.august'), value: 8 },
      { title: i18n.t('month.september'), value: 9 },
      { title: i18n.t('month.october'), value: 10 },
      { title: i18n.t('month.november'), value: 11 },
      { title: i18n.t('month.december'), value: 12 },
    ])

    const years = []
    for (let i = 2022; i < currentYear + 2; i++) {
      years.push(i)
    }

    const monthFilter = ref(currentMonth + 1)
    const yearFilter = ref(currentYear)
    const dateRangeFilter = props.resetDateButtonShow
      ? ref('')
      : props.dateRangeDaysLimit === 365
        ? default_language === 'en'
          ? ref(`${oneYearBeforeDate.getMonth() + 1}-${oneYearBeforeDate.getDate()}-${oneYearBeforeDate.getFullYear()} to ${currentMonth + 1}-${currentDay}-${currentYear}`)
          : ref(`${oneYearBeforeDate.getDate()}-${oneYearBeforeDate.getMonth() + 1}-${oneYearBeforeDate.getFullYear()} a ${currentDay}-${currentMonth + 1}-${currentYear}`)
        : default_language === 'en'
          ? ref(`${thirtyDaysBeforeDate.getMonth() + 1}-${thirtyDaysBeforeDate.getDate()}-${thirtyDaysBeforeDate.getFullYear()} to ${currentMonth + 1}-${currentDay}-${currentYear}`)
          : ref(`${thirtyDaysBeforeDate.getDate()}-${thirtyDaysBeforeDate.getMonth() + 1}-${thirtyDaysBeforeDate.getFullYear()} a ${currentDay}-${currentMonth + 1}-${currentYear}`)

    watch(() => props.calendarMonth, newVal => {
      monthFilter.value = newVal + 1
    })

    watch(() => props.calendarYear, newVal => {
      yearFilter.value = newVal
    })

    watch([locationFilter, roleFilter, privilegeFilter, processFilter, processTypeFilter, riskFilter, workerFilter, supervisorFilter, observerFilter, creatorFilter, monthFilter, yearFilter, pendingTasksFilter, instanceFilter, instanceLeaderFilter, zoneImprovementFilter, zoneFilter, agencyFilter, metadataFilter, rolPrivacyFilter, volumenFilter, ambitoFilter, sensiblesFilter, transferenciaFilter, levelFilter, eipdFilter, decisionFilter, statusFilter, gapStatusFilter, obligationFilter, overdueGapsFilter, companyFilter, idFilter, processResponsibleFilter, controlResponsibleFilter, crimeFilter, controlFilter, arsopblRightFilter, arsopblStageFilter, arsopblDeadlineFilter, inherentRiskFilter, residualRiskFilter], () => {
      emitChangeFilter()
    })

    const changeDateRangeFormat = range => {
      if (!range) return range
      const datesArray = range.split(' ')
      const dashSeparator = datesArray[0][2] === '-' || datesArray[0][1] === '-'
      let startArray = dashSeparator ? datesArray[0].split('-') : datesArray[0].split('/')
      startArray = [startArray[1], startArray[0], startArray[2]].join(dashSeparator ? '-' : '/')
      if (!datesArray[2]) return startArray
      let endArray = dashSeparator ? datesArray[2].split('-') : datesArray[2].split('/')
      endArray = [endArray[1], endArray[0], endArray[2]].join(dashSeparator ? '-' : '/')
      return `${startArray} ${datesArray[1]} ${endArray}`
    }

    const emitChangeFilter = () => {
      emit('changeFilter', {
        locationFilter: locationFilter.value,
        roleFilter: roleFilter.value,
        privilegeFilter: privilegeFilter.value,
        processFilter: processFilter.value,
        processTypeFilter: processTypeFilter.value,
        riskFilter: riskFilter.value,
        workerFilter: workerFilter.value,
        supervisorFilter: supervisorFilter.value,
        observerFilter: observerFilter.value,
        creatorFilter: creatorFilter.value,
        monthFilter: monthFilter.value - 1,
        yearFilter: yearFilter.value,
        pendingTasksFilter: pendingTasksFilter.value,
        dateRangeFilter: default_language === 'en' ? changeDateRangeFormat(dateRangeFilter.value) : dateRangeFilter.value,
        instanceFilter: instanceFilter.value,
        instanceLeaderFilter: instanceLeaderFilter.value,
        zoneImprovementFilter: zoneImprovementFilter.value,
        zoneFilter: zoneFilter.value,
        agencyFilter: agencyFilter.value,
        metadataFilter: metadataFilter.value,
        // Privacy filters
        rolPrivacyFilter: rolPrivacyFilter.value,
        volumenFilter: volumenFilter.value,
        ambitoFilter: ambitoFilter.value,
        sensiblesFilter: sensiblesFilter.value,
        transferenciaFilter: transferenciaFilter.value,
        levelFilter: levelFilter.value,
        eipdFilter: eipdFilter.value,
        decisionFilter: decisionFilter.value,
        statusFilter: statusFilter.value,
        gapStatusFilter: gapStatusFilter.value,
        obligationFilter: obligationFilter.value,
        overdueGapsFilter: overdueGapsFilter.value,
        // Process list filters
        companyFilter: companyFilter.value,
        idFilter: idFilter.value,
        processResponsibleFilter: processResponsibleFilter.value,
        controlResponsibleFilter: controlResponsibleFilter.value,
        crimeFilter: crimeFilter.value,
        controlFilter: controlFilter.value,
        // ARSOPBL filters
        arsopblRightFilter: arsopblRightFilter.value,
        arsopblStageFilter: arsopblStageFilter.value,
        arsopblDeadlineFilter: arsopblDeadlineFilter.value,
        // Risk filters
        inherentRiskFilter: inherentRiskFilter.value,
        residualRiskFilter: residualRiskFilter.value,
      })
    }

    // watch(dateRangeFilter, () => {
    //   // Limit the date range to the days limit received by props
    //   const datesArray = dateRangeFilter.value.split(" ")
    //   if (datesArray[2]) {
    //     datePickerConfig.value.minDate = null
    //     datePickerConfig.value.maxDate = null
    //   }
    //   else {
    //     const startArray = datesArray[0].split("-")
    //     const startDate = new Date(startArray[2], startArray[default_language === "en" ? 0 : 1] - 1, startArray[default_language === "en" ? 1 : 0])
    //     const startYear = startDate.getFullYear()
    //     const startMonth = startDate.getMonth()
    //     const startDay = startDate.getDate()
    //     const minDate = new Date(startYear, startMonth, startDay - props.dateRangeDaysLimit)
    //     const maxDate = new Date(startYear, startMonth, startDay + props.dateRangeDaysLimit)
    //     datePickerConfig.value.minDate = minDate
    //     datePickerConfig.value.maxDate = maxDate
    //   }
    // })

    watch(locations, () => {
      emit('locations', locations.value)
    })

    watch(supervisors, () => {
      emit('supervisors', supervisors.value)
    })

    watch(metadataTypeSelect, () => {
      if (metadataTypeSelect.value?.value?.length) {
        metadataFilter.value = metadataTypeSelect.value.value[0].value
        emit('setAddMetadataButtonStatus', true)
      } else {
        metadataFilter.value = ''
        emit('setAddMetadataButtonStatus', false)
      }
    })

    const resetDate = () => {
      dateRangeFilter.value = ''
    }

    // Filter data when a point from a chart is clicked
    const onFilterByLocation = locationId => {
      locationFilter.value = locationFilter.value.length === 1 && locationFilter.value[0] === locationId
        ? []
        : [locationId]
    }
    const onFilterByProcess = processId => {
      processFilter.value = processFilter.value.length === 1 && processFilter.value[0] === processId
        ? []
        : [processId]
    }
    const onFilterByWorker = workerId => {
      workerFilter.value = workerFilter.value.length === 1 && workerFilter.value[0] === workerId
        ? []
        : [workerId]
    }
    const onFilterBySupervisor = supervisorId => {
      supervisorFilter.value = supervisorFilter.value.length === 1 && supervisorFilter.value[0] === supervisorId
        ? []
        : [supervisorId]
    }
    const onFilterByCreator = creatorId => {
      creatorFilter.value = creatorFilter.value.length === 1 && creatorFilter.value[0] === creatorId
        ? []
        : [creatorId]
    }
    const onFilterByDate = date => {
      dateRangeFilter.value = `${date} to ${date}`
    }
    const onFilterBySupervisorAndProcess = (supervisorId, processId) => {
      const reset = supervisorFilter.value.length === 1 && supervisorFilter.value[0] === supervisorId && processFilter.value.length === 1 && processFilter.value[0] === processId
      supervisorFilter.value = reset ? [] : [supervisorId]
      processFilter.value = reset ? [] : [processId]
    }
    const onResetFilters = () => {
      workerFilter.value = []
      locationFilter.value = []
      pendingTasksFilter.value = false
      // Reset privacy filters
      rolPrivacyFilter.value = null
      volumenFilter.value = null
      ambitoFilter.value = null
      sensiblesFilter.value = null
      transferenciaFilter.value = null
      levelFilter.value = null
      eipdFilter.value = null
      decisionFilter.value = null
      statusFilter.value = null
      gapStatusFilter.value = null
      obligationFilter.value = null
      overdueGapsFilter.value = false
      // Reset ARSOPBL filters
      arsopblRightFilter.value = null
      arsopblStageFilter.value = null
      arsopblDeadlineFilter.value = null
      // Reset risk filters
      inherentRiskFilter.value = null
      residualRiskFilter.value = null
    }

    onMounted(() => {
      if (props.roleFilterShow) getRolesForDropDown()
      if (props.supervisorFilterShow || props.observerFilterShow || props.creatorFilterShow) getSupervisorsForDropDown()
      if (props.locationFilterShow) getLocationsForDropDown()
      if (props.processFilterShow || props.riskFilterShow) getProcessesForDropDown()
      if (props.workerFilterShow || props.processResponsibleFilterShow) getWorkersSupervisedForDropDown()
      if (props.zoneFilterShow || props.agencyFilterShow) getMetadataForDropDown({ category: 'filter' })
      if (props.metadataFilterShow) getMetadataForDropDown({ type: 'select' })
      if (props.companyFilterShow) getCompaniesForDropDown()
      if (props.activityFilterShow) getIDsForDropDown()
      if (props.crimeFilterShow) getCrimesForDropDown()
      if (props.controlResponsibleFilterShow) getResponsiblesForDropDown()
      if (props.controlFilterShow) getControlsForDropDown()
      if (props.obligationFilterShow) getGapObligationsForDropDown()

      EventBus.$on('filterByLocation', onFilterByLocation)
      EventBus.$on('filterByProcess', onFilterByProcess)
      EventBus.$on('filterByWorker', onFilterByWorker)
      EventBus.$on('filterBySupervisor', onFilterBySupervisor)
      EventBus.$on('filterByCreator', onFilterByCreator)
      EventBus.$on('filterByDate', onFilterByDate)
      EventBus.$on('filterBySupervisorAndProcess', onFilterBySupervisorAndProcess)
      EventBus.$on('resetFilters', onResetFilters)
    })

    onUnmounted(() => {
      EventBus.$off('filterByLocation', onFilterByLocation)
      EventBus.$off('filterByProcess', onFilterByProcess)
      EventBus.$off('filterByWorker', onFilterByWorker)
      EventBus.$off('filterBySupervisor', onFilterBySupervisor)
      EventBus.$off('filterByCreator', onFilterByCreator)
      EventBus.$off('filterByDate', onFilterByDate)
      EventBus.$off('filterBySupervisorAndProcess', onFilterBySupervisorAndProcess)
      EventBus.$off('resetFilters', onResetFilters)
    })

    return {
      locationFilter,
      roleFilter,
      privilegeFilter,
      privilegeOptions,
      processFilter,
      processTypeFilter,
      riskFilter,
      workerFilter,
      supervisorFilter,
      observerFilter,
      creatorFilter,
      monthFilter,
      yearFilter,
      pendingTasksFilter,
      dateRangeFilter,
      instanceFilter,
      instanceLeaderFilter,
      zoneImprovementFilter,
      locations,
      roles,
      processes,
      workersSupervised,
      supervisors,
      months,
      years,
      datePickerConfig,
      resetDate,
      optionsMetadata,
      zoneFilter,
      agencyFilter,
      metadataFilter,
      metadataFilterOptions,
      metadataTypeSelect,
      processTypes,
      // Privacy filters
      rolPrivacyFilter,
      volumenFilter,
      ambitoFilter,
      sensiblesFilter,
      transferenciaFilter,
      levelFilter,
      eipdFilter,
      decisionFilter,
      statusFilter,
      gapStatusFilter,
      obligationFilter,
      overdueGapsFilter,
      rolPrivacyOptions,
      volumenOptions,
      ambitoOptions,
      levelOptions,
      decisionOptions,
      statusOptions,
      gapStatusOptions,
      obligations,
      // Process list filters
      companyFilter,
      idFilter,
      processResponsibleFilter,
      controlResponsibleFilter,
      crimeFilter,
      controlFilter,
      companies,
      ids,
      crimes,
      responsibles,
      controls,
      // ARSOPBL filters
      arsopblRightFilter,
      arsopblStageFilter,
      arsopblDeadlineFilter,
      arsopblRightOptions,
      arsopblStageOptions,
      arsopblDeadlineOptions,
      // Risk filters
      inherentRiskFilter,
      residualRiskFilter,
      riskLevelOptions,
    }
  },
}
</script>

<style lang="scss" scoped>

</style>
